import React from 'react';
import {withRouter} from "react-router-dom";
import _ from "lodash";

import DashboardTable from "../../DashboardTable";
import tableStructure, {
  tableStructureTrading,
  tableStructureDepotstatus,
  tradingTableStructureDepotstatus,
  tableStructureVirtual,
  virtualTableStructureDepotstatus,
  tableStructureGrouping, tableStructureGroupingByProduct
} from "./table-data";

import useStyles, { useTradingTableClasses, useDepotstatusClasses, useVirtualTableClasses, useVirtualTableDepotstatusClasses } from "./styles";

import {isTradingEnabled} from "../../TradingStore/utils";
import {GROUP_ACTION_DEPOT, GROUP_ACTION_PRODUCT} from "./constants";
import {getSubSystemConfigItem} from "../../../utils/utils";
import {
  REPORT_TYPES
} from "../../../containers/DashboardSettings/components/CustomersList/components/ReportType/constants";


export const buildComponentsWithSubItemsDataSource = (components, isMpOrPi, subComponentsFieldName='component_sub_depots') => {
  return _.flatten((components || []).map((component) => {
    const isHeader = component[subComponentsFieldName] && !!component[subComponentsFieldName].length;
    return [{
      ...component,
      isMpOrPi,
      tableProps: {
        withoutHeader: !isHeader,
        isHeader
      }}, ...(component[subComponentsFieldName] || []).map((item) => ({...item, 'isSubItem': true}))]
  }))
}

const InstrumentsAllocationTable = (props) => {
  const classes = useStyles();
  const tradingClasses = useTradingTableClasses()
  const depotstatusClasses = useDepotstatusClasses()
  const virtualTableClasses = useVirtualTableClasses();
  const virtualDepotstatusClasses = useVirtualTableDepotstatusClasses();

  const {
    data,
    user,
    virtualInstrumentLink,
    expanded,
    expandedSubItems,
    onExpandedSubItems,
    match: {
      params: {
        customer_id,
        id,
      }
    },
    isCustomerApp,
    onAddTradingOption,
    tradings,
    tradeTransactions,
    reportType,
    isVirtual,
    refresh,
    isModelportfolio,
    isPtfTradingDisabled,
    custodiansInstrumentsData,
    loading,
    customerData,
    banksMapping,
    bankCode,
    instrumentsGroupBy,
    footerText
  } = props;

  const handleExpandedSubItemsChange = (elemId) => {
    onExpandedSubItems(data.id, {
      ...expandedSubItems,
      [elemId]: _.isNil(_.get(expandedSubItems, elemId)) ? true : !_.get(expandedSubItems, elemId)})
  };

  const dataSource =  React.useMemo(() => {
    const isMpOrPi = data.is_model_portfolio || data.is_private_investment;

    return buildComponentsWithSubItemsDataSource(data.components, isMpOrPi)
  }, [data]);

  let tradingEnabled = isTradingEnabled();

  const headerData = {
    trans_saldo_explanation: data.trans_saldo_explanation
  }

  const footerData = {
    market_value: data.market_value,
    invested_amount: data.invested_amount,
    profit_loss_eur: data.profit_loss_eur,
    profit_loss_perc: data.profit_loss_perc,
    profit_loss_percentage_pa: data.profit_loss_percentage_pa,
    portfolio_pa_warning: data.portfolio_pa_warning, // warning that is get from db if components of portfolio are younger than 360 days
    profit_value_start: data.profit_value_start,
    text: footerText
  }


  let tableStructureResult;
  let tableClasses;
  let isDepotStatus = reportType == REPORT_TYPES.DEPOT_STATUS.value;

  if (instrumentsGroupBy && instrumentsGroupBy !== GROUP_ACTION_DEPOT) {
    tableStructureResult = instrumentsGroupBy === GROUP_ACTION_PRODUCT
      ? tableStructureGroupingByProduct
      : tableStructureGrouping;
    tableClasses = classes;
  } else if (tradingEnabled && !isCustomerApp && !isPtfTradingDisabled) {
    tableStructureResult = isDepotStatus ? tradingTableStructureDepotstatus : tableStructureTrading;
    tableClasses = isDepotStatus ? depotstatusClasses : tradingClasses
  } else {
    if(isVirtual){
      tableStructureResult = isDepotStatus ? virtualTableStructureDepotstatus : tableStructureVirtual;
      tableClasses = isDepotStatus ? virtualDepotstatusClasses : virtualTableClasses;
    } else {
      tableStructureResult = isDepotStatus ? tableStructureDepotstatus : tableStructure;
      tableClasses = isDepotStatus ? depotstatusClasses : classes;
    }
  }

  return <DashboardTable
    structure={tableStructureResult}
    dataSource={dataSource}
    expanded={expanded}
    handleExpandedSubItemsChange={handleExpandedSubItemsChange}
    virtualInstrumentLink={virtualInstrumentLink}
    useInternalCollapse
    options={{
      resource: props.resource,
      customer_id: customer_id || id,
      footerData,
      headerData,
      trading: {
        loading: loading,
        subDepotTradeEnabled: getSubSystemConfigItem('trading', 'sub_depots_trade_enabled'),
        isModelportfolio,
        isVirtualOrderEnabled: props.isVirtualOrderEnabled,
        onAddTradingOption,
        portfolio: tradings,
        tradeTransactions: _.get(tradeTransactions, data.id),
        disabled: !isVirtual && !!tradeTransactions,  // disabled in case there are Trade Session transactions
        custodiansInstrumentsData: custodiansInstrumentsData,
        bankMapping: banksMapping && banksMapping.hasOwnProperty(bankCode) && banksMapping[bankCode],
        brokerLicense: user && user.bca_level_id,
        customerSrri: customerData && customerData.last_srri && customerData.last_srri.srri,
      },
      virtual: {
        portfolioId: data.id,
        numberOfAssets: data.number_of_assets,
        refresh: refresh
      },
      skipIndexReset: true
    }}
    tableClasses={tableClasses}
    showCell={props.showCell}
  />
};


export default withRouter(InstrumentsAllocationTable);